export default __webpack_public_path__ + "static/media/ziro.b481d39c.png";